import { useEffect, useState } from "react";
import TranslationMenu from "./TranslationMenu";

const TranslationMenuContainer=()=>{
    const [isVisible,setIsVisible]=useState(false);

    useEffect(()=>{
        setIsVisible(true);
    },[]);

    return(
        isVisible?<TranslationMenu/>:null
    )
}

export default TranslationMenuContainer;